
import getCraftPages from '~/queries/craft-pages.gql'
import getRelatedBlogs from '~/queries/related-blogs.gql'
import pageMixin from '@bkwld/cloak/mixins/page'

export default
	name: 'Blog'

	mixins: [ pageMixin ]

	data: ->
	 	# Related blog active on carousel mobile
		active: 0

	# Get Tower data
	asyncData: ({ app, store, params, $axios, route, query, req }) ->

		# Don't query for these paths
		return app.$notFound() if params.blog in [ '__webpack_hmr' ]

		# Get data
		[ page ] = await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'blogs'
				type: 'default'
				uri: "blogs/#{params.blog}"

		return app.$notFound() unless page

		{relatedBlogs} = await app.$craft.execute
			query: getRelatedBlogs
			variables:
				categoryId: [ page.blogCategories?[0]?.id ]

		return { page, relatedBlogs: relatedBlogs.filter (blog) -> blog.id != page.id  }

	computed:
		introCopy: -> @page.introCopy

		relatedBlogsToShow: -> @relatedBlogs.slice(0, 4)

		media: ->
			if @page.thumbnail?.length then return @page.thumbnail[0]
			if @page.highlightMedia?.length then return @page.highlightMedia[0]

		category: -> @page.blogCategories?[0]?.title || ''

		date: ->
			date = new Date @page.dateCreated
			date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

		author: -> @page.author

		title: -> @page.title

		readTime: -> @page.readTime

		highlightVideo: ->
			if @page.highlightVideo?.length then return @page.highlightVideo[0]
			else return null

		tags: -> @page.tags

		# Get current path
		currentURL: ->
			if process.server then return process.env.URL + @$route.fullPath
			else return window.location.href

		# Links to share
		shareLinks: ->
			twitter:
				href: "https://twitter.com/intent/tweet?text=Check+this+video+from+Nuro:+&url=#{@currentURL}&via=nuro"

			facebook:
				href: "https://www.facebook.com/sharer/sharer.php?u=#{ @currentURL }"

			linkedin:
				href: "https://www.linkedin.com/sharing/share-offsite/?url=#{@currentURL}"

			email:
				href: "mailto:?subject=#{@title}&body=#{@currentURL}"

	methods:
		goTo: (index) ->
			@$refs.carousel.goto index

		change: ({index}) ->
			@active = index

		playHighlightVideo: ->
			return unless @highlightVideo

			if window.innerWidth > 768
				mp4Video = @highlightVideo.videoDesktop[0]
			else
				mp4Video = @highlightVideo.videoMobile[0]

			if mp4Video then @$store.commit 'videoModal/play', {video: mp4Video, title: @highlightVideo.title, subtitles: @highlightVideo.subtitles, libraryVideoId: @highlightVideo.id }


		shareEmail: ->
			window.open @shareLinks.email.href, '_blank'

		shareLinkedin: ->
			window.open @shareLinks.linkedin.href, '_blank'

		shareX: ->
			window.open @shareLinks.twitter.href, '_blank'

		shareFacebook: ->
			window.open @shareLinks.facebook.href, '_blank'
